import {get, set} from 'lodash'

export default {
    setSiteData(state, siteData) {
        state.siteData = {...(state.siteData), ...siteData}
    },

    setBookingData(state, bookingData) {
        state.bookingData = {...(state.bookingData), ...bookingData}
    },

    setPreviewMode(state, previewMode) {
        state.previewMode = previewMode
    },

    setBookingProp(state, {prop, value, path = null}) {
        if (path === null) {
            set(state.bookingData, prop, value)
        } else {
            set(get(state.bookingData, path), prop, value)
        }
    },

    setSingleBooking(state, {booking, key}) {
        set(state.bookingData.bookings, key, booking)
    },

    setFormSelectChoices(state, formSelectChoices) {
        state.formSelectChoices = formSelectChoices
    },

    setBookingPerson(state, {person, key}) {
        set(state.bookingData.persons, key, person)
    },

    setSiteIsLoaded(state, isLoaded) {
        state.siteIsLoaded = isLoaded
    },

    setStepsValidationState(state, {step, isValid}) {
        set(state.stepsValidationState, step, isValid)
    },

    setBookingFinishedSuccessful(state) {
        state.bookingFinishedSuccessful = true
    },

    setAuthenticated(state, isAuthenticated) {
        state.isAuthenticated = isAuthenticated;
    },
    setAbilities(state, abilities) {
        state.abilities = abilities;
    },
    setUserData(state, userData) {
        state.userData = userData
    }
}
